export const PERIODS = ['7D', '1M', '3M', 'YTD', '1Y'] as const;

export type Period = (typeof PERIODS)[number];
